var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarBtnDesassociarEntrega)?_c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-trash fa-lg icon-button",attrs:{"title":"Desassociar Entrega"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarDesassociarEntrega(
                _vm.finalizacaoEntrega.finalizacaoEntregaId
            )}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }